export default {
	title: "Funciones",
	description: "Gestionar funciones espirituales y administrativas del terreiro",
	searchPlaceholder: "Buscar funciones...",
	create: "Nueva Función",
	deleteConfirmation: "¿Está seguro que desea eliminar la función {name}?",
	deleteWarning: "Esta acción es permanente. Todos los vínculos de personas con esta función serán eliminados.",
	confirmDeleteMessage: "¿Está seguro que desea eliminar esta función? Esta acción no se puede deshacer.",
	name: "Nombre",
	category: "Categoría",
	noCategory: "Sin categoría",
	newCategory: "Nueva categoría",
	personCount: "Personas Asignadas",
	peopleCount: "Personas",
	minimumJourney: "Jornada Mínima",
	noRequirement: "Sin Requisito",
	function: "Función",
	notes: "Observaciones",
	noFunctions: "Esta persona no tiene funciones asignadas",
	since: "Desde",
	deactivate: "Desactivar",
	reactivate: "Reactivar",
	endedAt: "Finalizado en",
	addFunction: "Agregar Función",
	selectFunction: "Seleccionar Función",
	requiredStage: "Etapa Req",
	minimumJourneyStageRequired: "Requiere etapa mínima: {stage}",
	journeyStageNotMet: "Etapa actual ({current}) no cumple el requisito mínimo ({required})",
	noCurrentStage: "Sin etapa",
	currentJourneyStage: "Etapa Actual del Viaje",
	minimumJourneyStage: "Etapa Mínima del Viaje",
	minimumJourneyStageHint: "Etapa mínima necesaria para ejercer esta función (opcional)",
	status: {
		active: "Activa",
		inactive: "Inactiva",
		all: "Todas",
	},
	stats: {
		total: "Total",
		withPersons: "Con Personas",
		withoutPersons: "Sin Personas",
	},
	empty: {
		title: "Ninguna función encontrada",
		description: "Registre las funciones espirituales y administrativas del terreiro",
	},
	messages: {
		activated: "Función activada con éxito",
		deactivated: "Función desactivada con éxito",
		createError: "Error al crear función",
		deleteError: "Error al eliminar función",
		fetchError: "Error al cargar funciones",
		loadError: "Error al cargar funciones",
		saveError: "Error al guardar función",
		createSuccess: "Función creada con éxito",
		updateSuccess: "Función actualizada con éxito",
		deleteSuccess: "Función eliminada con éxito",
	},
};
